import { mapState, mapGetters, mapActions } from 'vuex'

// 任意のサービスコンテンツに属するすべての「画面」から画面を選択するUIモジュール
// ●使用箇所
// 「サービス管理-コンテンツ設定-基本情報設定-ヘッダー設定」
// 「サービス管理-コンテンツ設定-基本情報設定-キーアサイン設定」
// 「サービス管理-コンテンツ設定-画面別設定-画面別コンテンツ編集-ボタン設定」
export default {
  name: 'ServiceContentsScreenSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    serviceContentsId: {
      type: String,
      require: true
    },
    // コンテンツ基本設定の新規登録時はサービスタイプが変更されるためここで受け取る
    serviceTypeCd: {
      type: Number,
      require: false,
      default: null
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: String,
      require: false,
      'default': () => ''
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    },
    overlay: {
      type:Boolean,
      default: () => false,
    }
  },
  data () {
    return {
      loading: true,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectServiceContentsScreenModal.buttonId,
      modalIndex: state => state.selectServiceContentsScreenModal.index,
      value: state => state.selectServiceContentsScreenModal.value
    }),
    ...mapGetters({
      getScreenName: 'selectServiceContentsScreenModal/getScreenName',
    }),

    screenName () {
      //TODO 画面名を取得
      return this.model
        ? this.getScreenName(this.model)
        : ''
    },

    showDeleteButton () {
      return this.model ? true : false
    }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to &&
        this.buttonId === this.name &&
        this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeScreen(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showSelectServiceContentsScreenModal: 'selectServiceContentsScreenModal/show',
      loadModel: 'selectServiceContentsScreenModal/loadModel',
      showError: 'error/show'
    }),

    init () {
      // RSS取得のためデータ読出
      this.loading = true

      //
      let serviceContentsParams = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId
      }

      // データ読出し
      this.loadModel({
        serviceContentsParams: serviceContentsParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    showScreenSelector () {
      this.showSelectServiceContentsScreenModal({
        serviceId: this.serviceId,
        serviceContentsId: this.serviceContentsId,
        serviceTypeCd: this.serviceTypeCd,
        buttonId: this.name,
        index: this.index,
        overlay: this.overlay,
      })
    },

    changeScreen (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    deleteScreen () {
      this.$emit('childs-delete', {
        name: this.name,
        index: this.index
      })
    }
  }
}